import { render } from "./FeedbackThree.vue?vue&type=template&id=6ddfbec0"
import script from "./FeedbackThree.vue?vue&type=script&lang=js"
export * from "./FeedbackThree.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__